module.exports = __webpack_public_path__ + "static/media/empresa-shopping-thumbnail-1-hd.d2779c8e.png";